import { Component, OnInit, ViewChild } from '@angular/core';
import { EngagementsService } from 'src/app/services/panelM/update-params/engagements.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminReportService } from 'src/app/services/panelM/update-params/adminReport.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditReportComponent } from '../../edit-report/edit-report.component';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { AdminModalConfirmComponent } from '../../admin-modal-confirm/admin-modal-confirm.component';

@Component({
  standalone: false,
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class AdminReportComponent implements OnInit {

  params: any;
  displayedColumns: string[] = ['reportType', 'ob_Channel', 'recipients', 'periodicity', 'button', 'delete'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private readonly adminReportService: AdminReportService,
    private readonly modal: MatDialog,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router
  ) { }

  ngOnInit() {
    this.initData();
  }


  openCreateModal(element: any = {}) {
    const form = this.formBuilder.group({
      reportType: new UntypedFormControl(element.reportType || '', [Validators.required]),
      ob_Channel: new UntypedFormControl(element.ob_Channel || '', [Validators.required]),
      recipients: new UntypedFormControl(element.recipients || '', [Validators.required]),
      periodicity: new UntypedFormControl(element.periodicity || 'D', [Validators.required])
    }, {});
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-admin';
    modalConfig.maxWidth = '500px';
    modalConfig.maxHeight = '614px';
    modalConfig.disableClose = true;
    modalConfig.data = {
      title: element.idReportRecipient ? 'Editar reporte' : 'Crear nuevo reporte',
      buttonText: element.idReportRecipient ? 'Editar' : 'Crear',
      form: form,
      formFields: {
        reportType: {
          text: 'Tipo',
          value: ''
        },
        recipients: {
          text: 'Destinatarios (Separar con una coma)',
          value: '',
          type: 'chip'
        },
        ob_Channel: {
          text: 'Canal de contratación',
          value: ''
        },
        periodicity: {
          text: 'Periodo',
          value: 'D',
          values: [
            {
              text: 'Diaria',
              value: 'D'
            },
            {
              text: 'Semanal',
              value: 'S'
            },
            {
              text: 'Mensual',
              value: 'M'
            }
          ]
        }
      }
    }
    const mod = this.modal.open(EditReportComponent, modalConfig);
    mod.afterClosed().subscribe(data => {
      if (data) {
        if (element.idReportRecipient) {
          data.idReportRecipient = element.idReportRecipient;
          this.adminReportService.updateReport(data).subscribe(() => this.initData());
        } else {
          this.adminReportService.createReport(data).subscribe(() => this.initData());
        }
      }
    })
  }

  openDeleteModal(element) {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-admin';
    modalConfig.maxWidth = '500px';
    modalConfig.maxHeight = '215px';
    modalConfig.disableClose = true;
    modalConfig.data = {
      title: 'Aviso',
      message: '¿Quieres borrar este reporte?',
      accept: 'Borrar',
      cancel: 'Cancelar'
    }
    const mod = this.modal.open(AdminModalConfirmComponent, modalConfig);
    mod.afterClosed().subscribe(data => {
      if (data) {
        this.adminReportService.deleteReport(element.idReportRecipient).subscribe(() => this.initData());
      }
    })
  }

  showPeriodicity(p: string) {
    const map = {
      D: 'Diaria',
      M: 'Mensual',
      S: 'Semanal'
    };
    return map[p];
  }

  showRecipients(r: string) {
    return r.replace(',', ', ')
  }

  private addId(list: any) {
    list.map((element, index) => {
      element.id_row = index + 1;
    });
    return list;
  }

  private initData() {
    this.adminReportService.getReports().subscribe(data => {
      this.params = new MatTableDataSource<any>(this.addId(data.listReportRecipient));
      this.params.paginator = this.paginator;
    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
  }
}
